// TODO: fetch exchanges from API
export const EXCHANGES = [
  "NYSE",
  "NASDAQ",
  "LSE",
  "TSE",
  "BSE",
  "NSE",
  "ASX",
  "TSX",
  "XETRA",
  "EURONEXT",
  "HKEX",
  "SGX",
  "JSE",
  "OTHER",
];

// TODO: fetch currencies from a currency API
export const CURRENCIES = [
  "USD",
  "EUR",
  "GBP",
  "KES",
  "NGN",
  "ZAR",
  "INR",
  "JPY",
  "CAD",
  "AUD",
  "CHF",
  "CNY"
];

export const ACCOUNT_TYPES = [
  "bank",
  "mobile_money",
  "card",
];

export const STATUSES = ["active", "inactive"];
export const BANK_SUBTYPES = ["savings", "current"] as const;
export const CARD_SCHEMES = [
  "visa",
  "mastercard",
  "amex",
  "discover",
  "unionpay",
  "other",
] as const;

export const MOBILE_MONEY_PROVIDERS = [
  "M-Pesa",
  "MTN Mobile Money",
  "Airtel Money",
  "Vodacom M-Pesa",
  "Orange Money",
  "Tigo Pesa",
  "Other",
] as const;

/**
 * Represents the duration, in milliseconds, after which cached data is considered stale.
 * This variable can be used to manage cache expiration policies or optimize data refreshing logic.
 */
export const CACHE_STALE_TIME_MINS = 10 * 60 * 1000;
